import React from "react";
import PartyPage from "./PartyPage";

export default function SuppliersPage() {
  return <PartyPage kind="supplier" />;
}
